const languageForms = document.querySelectorAll('.language-form');

if (languageForms.length > 0) {
  const updateFormState = (form) => {
    const regionDropdown = form.querySelector('[data-region-dropdown]');
    const btn = form.querySelector('[data-language-submit]');

    const regionSelected = regionDropdown.querySelector('input:checked');
    const isValid = Boolean(regionSelected && regionSelected.value);
    btn.classList.toggle('btn--disabled', !isValid);
    btn.disabled = !isValid;
  };

  languageForms.forEach((form) => {
    form.addEventListener('change', () => updateFormState(form));

    const btn = form.querySelector('[data-language-submit]');
    btn.addEventListener('click', () => {
      if (!form.hasAttribute('data-language-redirect')) {
        return;
      }

      const regionSelected = form.querySelector('[data-region-dropdown] input:checked');

      if (regionSelected && regionSelected.value) {
        window.location.href = regionSelected.value;
      }
    });

    updateFormState(form);
  });
}
